/**
 * 百度统计工具
 */

// 声明全局类型
declare global {
    interface Window {
        _hmt: any[];
    }
}

/**
 * 百度统计事件上报
 * @param category 事件类别（必填）
 * @param action 事件动作（必填）
 * @param label 事件标签（可选）
 * @param value 事件值（可选）
 */
export function trackEvent(category: string, action: string, label?: string, value?: number) {
    // 如果未初始化，尝试等待一段时间后重试
    // 如果 _hmt 数组存在但未初始化，等待后重试
    if (typeof window !== 'undefined' && window._hmt && Array.isArray(window._hmt)) {
        setTimeout(() => {
            trackEvent(category, action, label, value);
        }, 500);
        return;
    }
    return;
}

/**
 * 页面访问统计
 * @param pagePath 页面路径
 * @param pageTitle 页面标题（可选，用于设置 document.title）
 */
export function trackPageView(pagePath: string, pageTitle?: string) {
    // 如果未初始化，尝试等待一段时间后重试
    // 如果 _hmt 数组存在但未初始化，等待后重试
    if (typeof window !== 'undefined' && window._hmt && Array.isArray(window._hmt)) {
        setTimeout(() => {
            trackPageView(pagePath, pageTitle);
        }, 500);
        return;
    }
    return;
}
